import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const Logout = () =>
    request({
        url: ApiURL.Query.Logout,
        method: RequestType.GET,
        skipErrorModal: true,
    });

const AuthQuery = {
    Logout,
};

export default AuthQuery;
